import src from "IMAGE";
export default { src, width: 900, height: 159, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AJqamnJlZWVNbm5uW2tra1piYmJRdHR0X2hoaFRtbW1c5WANXsSqKk8AAAAASUVORK5CYII="};
